export default __webpack_public_path__ + "static/N0305-f08bae66b803a670973b9c761a6568f9.png";